<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="30%"
    append-to-body
    :before-close="handleClose"
  >
    <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
      <div>修改资源说明</div>
    </div>
    <div class="bj">
        <div class="typevideo" v-if="message.type=='video'">
          <div class="keys">
            <div style="width:80px;">拍摄时间：</div>
                <el-date-picker
                  type="date"
                  v-model="message.exif.exif.CreateAt"
                  placeholder="选择日期">
                </el-date-picker>
          </div>
          <div class="keys">
            <div style="width:100px;">拍摄地点：</div>
            <el-input
             placeholder="请输入拍摄地点"
             v-model="message.exif.exif.videoAddress">
             </el-input>
          </div>
          <div class="keys">
            <div style="width:100px;">视频人物：</div>
            <el-input
             placeholder="请输入视频人物"
             v-model="message.exif.exif.videoCharacter">
             </el-input>
          </div>
          <div class="keys">
            <div style="width:100px;">视频事件：</div>
            <el-input
             placeholder="请输入视频事件"
             v-model="message.exif.exif.videoEvent">
             </el-input>
          </div>
          <div class="keys">
            <div style="width:100px;">视频分类：</div>
            <el-input
             placeholder="请输入视频分类"
             v-model="message.exif.exif.videoClassification">
             </el-input>
          </div>
        </div>
      <div class="bjs"> 
        <div style="width:100px;">资源说明：</div>
          <el-input
            placeholder="请输入资源说明"
            v-model="message.desc">
          </el-input>
        </div>
      <div class="bjs" v-if="message.resourceType=='picture'"> 
        <div style="width:100px;">作者：</div>
          <el-input
            placeholder="请输入作者"
            v-model="data">
          </el-input>
        </div>

    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" type="primary" @click="changeDesc">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: [
    'message',
    'dialogVisible',
  ],
  watch: {
    dialogVisible: {
      deep: true,
      handler(v) {
        this.dialogVisible = v;
      },
    },
  },
  data() {
    return {
      msg:'',
      data:''
    };
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
    changeDesc(){
      if(this.message.resourceType=='picture'){
        this.message.fileExif.author= this.data
        this.$emit('changeDesc',this.message)
      }else{
          this.$emit('changeDesc',this.message)
      }
      
    }
  },
  created() {
    if(this.message.resourceType=='picture'){
         this.data= this.message.fileExif.author
         console.log(this.data);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
.bj{
  display: flex;
  align-items: center;
  flex-direction: column;
  .bjs{
    display: flex;
     align-items: center;
     margin-top: 10px;
  }
  .typevideo{
    display: flex;
    align-items: center;
    flex-direction: column;
    .keys{
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
  }
}
</style>